import styled, { css } from "styled-components";

const CustomTable = styled.table<{ showHead?: boolean }>`
  width: 100%;
  border: none;
  border-collapse: collapse;
  table-layout: fixed;

  ${({ theme, showHead }) => css`
    ${theme.media.notSmall} {
      th {
        ${showHead ? "" : "display: none;"}
      }
    }

    ${theme.media.small} {
      th,
      td {
        &:first-child {
          display: none;
        }
      }
    }
  `}
`;

const Th = styled.th`
  background-color: ${({ theme }) => theme.color.grey[100]};
  padding: 1.4rem 2rem;

  color: ${({ theme }) => theme.color.text.tertiery};
  text-align: left;
  ${({ theme }) => theme.typography.body1.medium}

  ${({ theme }) => css`
    ${theme.media.small} {
      padding: 0.8rem;

      ${({ theme }) => theme.typography.caption1.medium}
    }
  `}
`;

const Thead = styled.thead``;

const Tbody = styled.tbody`
  tr {
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.stroke.light};

    &:last-child {
      border: none;
    }
  }
`;

const Tr = styled.tr``;

const Td = styled.td`
  padding: 1rem 2rem;
  box-sizing: border-box;
  ${({ theme }) => theme.typography.body1.regular}
  letter-spacing: -0.048rem;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${({ theme }) => css`
    ${theme.media.small} {
      padding: 1.2rem 0.8rem;

      ${({ theme }) => theme.typography.caption1.regular}
    }
  `}
`;

const TableLayout = styled.div`
  width: 100%;
  overflow: scroll;
`;

export const DashboardTable = {
  Layout: TableLayout,
  Table: CustomTable,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
};
